import { render } from "./UpdateTranslation.vue?vue&type=template&id=330f5019"
import script from "./UpdateTranslation.vue?vue&type=script&lang=js"
export * from "./UpdateTranslation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__